import React from "react";
import "./CustomComponentStyles.css";

const TextfieldCust = ({
  id,
  name,
  placeholder,
  value,
  onChange,
  InputProps,
  error,
  helperText,
  rows,
  multiline
}) => {
  return (
    <div className="w-100">
      {multiline ? (
        <textarea
          id={id}
          name={name}
          className="textfield-cust"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          rows={rows}
          style={{ resize: "vertical" }} 
        />
      ) : (
        <input
          type="text"
          id={id}
          name={name}
          className="textfield-cust"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          InputProps={InputProps}
        />
      )}
      {error && <p className="helper-text">{helperText}</p>}
    </div>
  );
};

export default TextfieldCust;